@if (material) {
  <form [formGroup]="form" (ngSubmit)="onSubmit()">
    <div class="row">
      <div class="col-md-2 text-center">
        @if (thumbnailSrc) {
          <img
            [src]="thumbnailSrc"
            class="img-fluid mb-2 border"
            [alt]="'forms.common.aria.thumbnailAlt' | translate" />
        } @else {
          @if (learningResourceTypesCtrl.value?.length > 0) {
            <div>
              <img
                src="assets/img/thumbnails/{{ learningResourceTypesCtrl.value[0].key }}.png"
                class="img-fluid mb-2 border"
                [alt]="'forms.common.aria.thumbnailAlt' | translate" />
            </div>
          } @else {
            <div class="material-image-upload d-flex justify-content-center mb-2 border mx-auto">
              <img src="assets/img/icons/ic_camera.svg" alt="" />
            </div>
          }
        }
        <button type="button" class="btn btn-blue mb-2" (click)="openThumbnailModal(thumbnail)">
          {{ "forms.educationalResource.basicDetails.uploadImage" | translate }}
        </button>
        <p class="thumbnail-help">
          <small>{{ "forms.educationalResource.basicDetails.thumbnailHelp" | translate }}</small>
        </p>
        <ng-template #thumbnail>
          <div class="modal-header">
            <h5 class="modal-title">{{ "forms.educationalResource.basicDetails.image.modal.title" | translate }}</h5>
            <button
              type="button"
              class="btn-close"
              [attr.aria-label]="'forms.common.close' | translate"
              (click)="thumbnailModalRef.hide()"></button>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label for="image">{{ "forms.educationalResource.basicDetails.image.label" | translate }}</label>
              <app-tooltip-button key="forms.educationalResource.basicDetails.image.tooltip" variant="help"></app-tooltip-button>
              <input
                type="file"
                class="form-control"
                id="image"
                accept="image/png,image/jpeg"
                [lang]="lang"
                (change)="imageChange($event)" />
            </div>
            <div class="form-group">
              <image-cropper
                [imageChangedEvent]="imageChangedEvent"
                [maintainAspectRatio]="true"
                [containWithinAspectRatio]="true"
                [aspectRatio]="152 / 228"
                [resizeToWidth]="152"
                [cropperMinWidth]="152"
                [resizeToHeight]="228"
                [cropperMinHeight]="228"
                (imageCropped)="imageCropped($event)"
                alignImage="left"
                output="base64"
              backgroundColor="#f2f2f2"></image-cropper>
            </div>
            @if (croppedImage) {
              <img [src]="croppedImage.base64" class="border" />
            }
            @if (uploadResponse.status === 'progress') {
              <div class="form-group">
                <progressbar
                  [max]="100"
                  [value]="+uploadResponse.message"
                  >{{ uploadResponse.message }}%</progressbar
                >
              </div>
            }
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-gray"
              [attr.aria-label]="'forms.common.close' | translate"
              (click)="thumbnailModalRef.hide()">
              {{ "forms.common.close" | translate }}
            </button>
            <button type="button" class="btn btn-blue" (click)="uploadImage()">
              {{ "forms.common.saveChanges" | translate }}
            </button>
          </div>
        </ng-template>
        <!--/modal-->
      </div>
      <!--/thumbnail-->
      <div class="col-md-10">
        <h3>{{ "forms.educationalResource.basicDetails.author.title" | translate }}*</h3>
        @for (author of authorsArray.controls; track author; let i = $index) {
          <fieldset class="border-bottom mb-2">
            <div class="row g-2" formArrayName="authors">
              <ng-container [formGroupName]="i">
                <!--if author & organization-->
                @if (author.get('author')) {
                  <div class="form-group col-md">
                    <label for="{{ 'author' + i }}">
                      {{ "forms.educationalResource.basicDetails.author.inputs.author.label" | translate }}*
                    </label>
                    <app-tooltip-button key="forms.educationalResource.basicDetails.author.inputs.author.tooltip" variant="help"></app-tooltip-button>
                    <input
                      type="text"
                      class="form-control"
                      id="{{ 'author' + i }}"
                    [placeholder]="
                      'forms.educationalResource.basicDetails.author.inputs.author.placeholder' | translate
                    "
                      formControlName="author"
                    [ngClass]="{
                      'is-invalid':
                        authorsArray.at(i).get('author').invalid &&
                        (authorsArray.at(i).get('author').dirty ||
                          authorsArray.at(i).get('author').touched ||
                          submitted)
                    }"
                      [attr.aria-describedby]="'author-help-' + i" />
                    <small [id]="'author-help-' + i" class="form-text text-muted">
                      {{ "forms.educationalResource.basicDetails.author.inputs.author.helpText" | translate }}
                    </small>
                    @if (
                      authorsArray.at(i).get('author').invalid &&
                      (authorsArray.at(i).get('author').dirty || authorsArray.at(i).get('author').touched || submitted)
                      ) {
                      <div
                        class="invalid-feedback">
                        @if (authorsArray.at(i).get('author').errors.invalidCharacters) {
                          <div>
                            {{ "forms.errors.textInput.characters" | translate }}
                          </div>
                        }
                        @if (authorsArray.at(i).get('author').errors.maxlength) {
                          <div>
                            {{ "forms.errors.common.maxLength" | translate: { maxLength:
                            authorsArray.at(i).get("author").errors.maxlength.requiredLength } }}
                          </div>
                        }
                      </div>
                    }
                  </div>
                  <div class="form-group col-md">
                    <label [for]="'affiliate' + i">
                      {{ "forms.educationalResource.basicDetails.author.inputs.affiliate.label" | translate }}
                    </label>
                    <app-tooltip-button key="forms.educationalResource.basicDetails.author.inputs.affiliate.tooltip" variant="help"></app-tooltip-button>
                    <ng-select
                      [items]="organizations"
                      [virtualScroll]="true"
                      [addTag]="addCustomItem"
                      bindLabel="value"
                      [id]="'affiliate' + i"
                      [labelForId]="'affiliate' + i"
                    formControlName="organization"></ng-select>
                  </div>
                }
                <!--if organization-->
                @if (!author.get('author')) {
                  <div class="form-group col">
                    <label [for]="'organization' + i">
                      {{ "forms.educationalResource.basicDetails.author.inputs.organization.label" | translate }}
                    </label>
                    <app-tooltip-button key="forms.educationalResource.basicDetails.author.inputs.organization.tooltip" variant="help"></app-tooltip-button>
                    <ng-select
                      [items]="organizations"
                      [virtualScroll]="true"
                      [addTag]="addCustomItem"
                      bindLabel="value"
                      [id]="'organization' + i"
                      [labelForId]="'organization' + i"
                    formControlName="organization"></ng-select>
                  </div>
                }
                <div class="form-group col-12">
                  <button type="button" class="btn btn-danger" (click)="removeAuthor(i)">
                    {{ "forms.common.delete" | translate }}
                  </button>
                </div>
              </ng-container>
            </div>
          </fieldset>
        }
        <div class="form-group">
          <button type="button" class="btn btn-gray me-2" (click)="addAuthor()">
            {{ "forms.educationalResource.basicDetails.author.addAuthor" | translate }}
          </button>
          <button type="button" class="btn btn-gray" (click)="addOrganization()">
            {{ "forms.educationalResource.basicDetails.author.addOrganization" | translate }}
          </button>
        </div>
        <h3>{{ "forms.educationalResource.basicDetails.otherDetails.title" | translate }}</h3>
        <div class="form-group">
          <label for="keywords">{{ "forms.educationalResource.basicDetails.keywords.label" | translate }}*</label>
          <app-tooltip-button key="forms.educationalResource.basicDetails.keywords.tooltip" variant="help"></app-tooltip-button>
          <ng-select
            [items]="keywords"
            [virtualScroll]="true"
            [multiple]="true"
            [addTag]="addCustomItem"
            bindLabel="value"
            id="keywords"
            labelForId="keywords"
            formControlName="keywords"
            (paste)="(false)"
          aria-describedby="keywords-help"></ng-select>
          <small id="keywords-help" class="form-text text-muted">
            {{ "forms.educationalResource.basicDetails.keywords.helpText" | translate }}
          </small>
        </div>
        <!--/keywords-->
        <div class="row g-2">
          <div class="form-group col-md-6 col-lg-4">
            <label for="learningResourceTypes">
              {{ "forms.educationalResource.basicDetails.learningResourceTypes.label" | translate }}*
            </label>
            <app-tooltip-button key="forms.educationalResource.basicDetails.learningResourceTypes.tooltip" variant="help"></app-tooltip-button>
            <ng-select
              [items]="learningResourceTypes"
              [multiple]="true"
              [closeOnSelect]="false"
              bindLabel="value"
              id="learningResourceTypes"
              labelForId="learningResourceTypes"
            formControlName="learningResourceTypes"></ng-select>
          </div>
          <!--/learning resource types-->
          <div class="form-group col-md-6 col-lg-4">
            <label for="educationalRoles">
              {{ "forms.educationalResource.basicDetails.educationalRoles.label" | translate }}
            </label>
            <app-tooltip-button key="forms.educationalResource.basicDetails.educationalRoles.tooltip" variant="help"></app-tooltip-button>
            <ng-select
              [items]="educationalRoles"
              [multiple]="true"
              [closeOnSelect]="false"
              bindLabel="value"
              id="educationalRoles"
              labelForId="educationalRoles"
            formControlName="educationalRoles"></ng-select>
          </div>
          <!--/educational roles-->
          <div class="form-group col-md-6 col-lg-4">
            <label for="educationalUses">
              {{ "forms.educationalResource.basicDetails.educationalUses.label" | translate }}
            </label>
            <app-tooltip-button key="forms.educationalResource.basicDetails.educationalUses.tooltip" variant="help"></app-tooltip-button>
            <ng-select
              [items]="educationalUses"
              [multiple]="true"
              [closeOnSelect]="false"
              bindLabel="value"
              id="educationalUses"
              labelForId="educationalUses"
            formControlName="educationalUses"></ng-select>
          </div>
          <!--/educational uses-->
        </div>
        <!--/row-->
        <div class="form-group" formGroupName="description">
          <label for="description">
            {{ "forms.educationalResource.basicDetails.description.label." + lang | translate }}
          </label>
          <app-tooltip-button key="forms.educationalResource.basicDetails.description.tooltip" variant="help"></app-tooltip-button>
          <div class="row g-2">
            <div class="col-sm">
              <textarea
                class="form-control"
                id="description"
                rows="10"
                [formControlName]="lang"
              [ngClass]="{
                'is-invalid':
                  descriptionCtrl.get(lang).invalid &&
                  (descriptionCtrl.get(lang).dirty || descriptionCtrl.get(lang).touched || submitted)
              }"></textarea>
              @if (
                descriptionCtrl.get(lang).invalid &&
                (descriptionCtrl.get(lang).dirty || descriptionCtrl.get(lang).touched || submitted)
                ) {
                <div
                  class="invalid-feedback">
                  @if (descriptionCtrl.get(lang).errors.invalid) {
                    <div>
                      {{ "forms.errors.description.characters" | translate }}
                    </div>
                  }
                  @if (descriptionCtrl.get(lang).errors.maxlength) {
                    <div>
                      {{ "forms.errors.common.maxLength" | translate: { maxLength:
                      descriptionCtrl.get(lang).errors.maxlength.requiredLength } }}
                    </div>
                  }
                </div>
              }
            </div>
            <div class="col-auto">
              <div class="mb-2">
                <button
                  type="button"
                  class="btn btn-gray"
                  (click)="openTranslationsModal(langVersions)"
                [ngClass]="{
                  'is-invalid': descriptionCtrl.get(otherLangs[0]).invalid || descriptionCtrl.get(otherLangs[1]).invalid
                }">
                  {{ "forms.common.translations.label" | translate }}
                </button>
                <app-tooltip-button key="forms.common.translations.tooltip" variant="help"></app-tooltip-button>
                @if (descriptionCtrl.get(otherLangs[0]).invalid || descriptionCtrl.get(otherLangs[1]).invalid) {
                  <div
                    class="invalid-feedback">
                    {{ "forms.errors.common.translations" | translate }}
                  </div>
                }
              </div>
              <button
                type="button"
                class="btn btn-outline-gray"
                (click)="openExampleDescriptionModal(exampleDescription)">
                {{ "forms.educationalResource.basicDetails.description.example.button" | translate }}
              </button>
            </div>
          </div>
          <ng-template #langVersions>
            <div class="modal-header">
              <h5 class="modal-title">
                {{ "forms.educationalResource.basicDetails.description.modal.title" | translate }}
              </h5>
              <button
                type="button"
                class="btn-close"
                [attr.aria-label]="'forms.common.close' | translate"
                (click)="translationsModalRef.hide()"></button>
            </div>
            <div class="modal-body">
              <h4>{{ "forms.educationalResource.basicDetails.description.modal.subtitle" | translate }}</h4>
              <div class="form-group">
                <label for="description2">
                  {{ "forms.educationalResource.basicDetails.description.label." + otherLangs[0] | translate }}
                </label>
                <textarea
                  class="form-control"
                  id="description2"
                  rows="10"
                  [formControlName]="otherLangs[0]"
                [ngClass]="{
                  'is-invalid':
                    descriptionCtrl.get(otherLangs[0]).invalid &&
                    (descriptionCtrl.get(otherLangs[0]).dirty ||
                      descriptionCtrl.get(otherLangs[0]).touched ||
                      submitted)
                }"></textarea>
                @if (
                  descriptionCtrl.get(otherLangs[0]).invalid &&
                  (descriptionCtrl.get(otherLangs[0]).dirty || descriptionCtrl.get(otherLangs[0]).touched || submitted)
                  ) {
                  <div
                    class="invalid-feedback">
                    @if (descriptionCtrl.get(otherLangs[0]).errors.invalid) {
                      <div>
                        {{ "forms.errors.description.characters" | translate }}
                      </div>
                    }
                    @if (descriptionCtrl.get(otherLangs[0]).errors.maxlength) {
                      <div>
                        {{ "forms.errors.common.maxLength" | translate: { maxLength:
                        descriptionCtrl.get(otherLangs[0]).errors.maxlength.requiredLength } }}
                      </div>
                    }
                  </div>
                }
              </div>
              <div class="form-group">
                <label for="description3">
                  {{ "forms.educationalResource.basicDetails.description.label." + otherLangs[1] | translate }}
                </label>
                <textarea
                  class="form-control"
                  id="description3"
                  rows="10"
                  [formControlName]="otherLangs[1]"
                [ngClass]="{
                  'is-invalid':
                    descriptionCtrl.get(otherLangs[1]).invalid &&
                    (descriptionCtrl.get(otherLangs[1]).dirty ||
                      descriptionCtrl.get(otherLangs[1]).touched ||
                      submitted)
                }"></textarea>
                @if (
                  descriptionCtrl.get(otherLangs[1]).invalid &&
                  (descriptionCtrl.get(otherLangs[1]).dirty || descriptionCtrl.get(otherLangs[1]).touched || submitted)
                  ) {
                  <div
                    class="invalid-feedback">
                    @if (descriptionCtrl.get(otherLangs[1]).errors.invalid) {
                      <div>
                        {{ "forms.errors.description.characters" | translate }}
                      </div>
                    }
                    @if (descriptionCtrl.get(otherLangs[1]).errors.maxlength) {
                      <div>
                        {{ "forms.errors.common.maxLength" | translate: { maxLength:
                        descriptionCtrl.get(otherLangs[1]).errors.maxlength.requiredLength } }}
                      </div>
                    }
                  </div>
                }
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-gray"
                [attr.aria-label]="'forms.common.cancel' | translate"
                (click)="translationsModalRef.hide()">
                {{ "forms.common.cancel" | translate }}
              </button>
              <button type="button" class="btn btn-blue" (click)="translationsModalRef.hide()">
                {{ "forms.common.saveChanges" | translate }}
              </button>
            </div>
          </ng-template>
          <ng-template #exampleDescription>
            <div class="modal-header">
              <h5 class="modal-title">
                {{ "forms.educationalResource.basicDetails.description.example.title" | translate }}
              </h5>
              <button
                type="button"
                class="btn-close"
                [attr.aria-label]="'forms.common.close' | translate"
                (click)="exampleDescriptionModalRef.hide()"></button>
            </div>
            <div class="modal-body">
              <p>{{ "forms.educationalResource.basicDetails.description.example.description" | translate }}</p>
              <p class="font-italic">
                {{ "forms.educationalResource.basicDetails.description.example.details" | translate }}
                <a href="https://aoe.fi/materiaali/606">
                  {{ "forms.educationalResource.basicDetails.description.example.detailsLink" | translate }}
                </a>
                .
              </p>
              <h4>{{ "forms.educationalResource.basicDetails.description.example.subtitleTrunc" | translate }}</h4>
              <p>{{ "forms.educationalResource.basicDetails.description.example.detailsTrunc" | translate }}</p>
              <img
                src="assets/img/description-example-card.png"
                alt="example description card"
                class="img-fluid border" />
            </div>
            <div class="modal-footer">
              <button
                type="button"
                class="btn btn-gray"
                [attr.aria-label]="'forms.common.cancel' | translate"
                (click)="exampleDescriptionModalRef.hide()">
                {{ "forms.common.close" | translate }}
              </button>
            </div>
          </ng-template>
        </div>
        <!--/description-->
      </div>
      <!--/right-column-->
    </div>
    <div class="row">
      <div class="col">
        <button type="button" class="btn btn-gray" (click)="previous()">{{ "forms.common.previous" | translate }}</button>
      </div>
      <div class="col-auto">
        <button type="reset" class="btn btn-cancel" (click)="abort()">{{ "forms.common.abort" | translate }}</button>
      </div>
      <div class="col-auto">
        <button type="submit" class="btn btn-blue">{{ "forms.common.next" | translate }}</button>
      </div>
    </div>
  </form>
}
